import React from "react";
import { Landmark } from "lucide-react";
import { money } from "@/components/obboard/BoardFilters";

const Stat = ({ label, t, tone, testid }) => (
  <div className="flex items-baseline justify-between gap-2 py-1.5" data-testid={testid}>
    <span className="text-xs text-slate-600">{label} <span className="text-slate-400">({t?.count ?? 0})</span></span>
    <span className={`mono text-sm font-semibold ${tone}`}>{money(t?.amount)}</span>
  </div>
);

export const MonthSummary = ({ totals, balance }) => (
  <div className="space-y-4">
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="ob-month-totals">
      <div className="text-sm font-semibold text-slate-900 mb-1">This month</div>
      <Stat label="Total due" t={totals.all} tone="text-slate-900" testid="ob-total-all" />
      <Stat label="Paid" t={totals.paid} tone="text-emerald-700" testid="ob-total-paid" />
      <Stat label="Upcoming" t={totals.pending} tone="text-blue-800" testid="ob-total-pending" />
      <Stat label="Overdue" t={totals.overdue} tone="text-rose-700" testid="ob-total-overdue" />
    </div>
    <BalanceList rows={balance} />
  </div>
);

export const BalanceList = ({ rows }) => (
  <div className="bg-white border border-blue-200 rounded-lg p-4" data-testid="ob-balance-required">
    <div className="flex items-center gap-2 text-sm font-semibold text-slate-900"><Landmark className="w-4 h-4 text-blue-700" />Bank balance required</div>
    <div className="text-[11px] text-slate-500 mb-2">Unpaid amounts (upcoming + overdue) this month, per entity</div>
    {rows.length === 0 ? <div className="text-xs text-slate-500 py-3" data-testid="ob-balance-empty">Nothing left to pay this month.</div> : rows.map((r) => (
      <div key={r.entity} className="py-2 border-t border-slate-100 first:border-0" data-testid={`ob-balance-${r.entity}`}>
        <div className="flex items-baseline justify-between gap-2">
          <span className="text-sm text-slate-800 truncate">{r.entity === "—" ? "No entity" : r.entity}</span>
          <span className="mono text-sm font-semibold text-blue-800">{money(r.required)}</span>
        </div>
        <div className="text-[11px] text-slate-500">
          {r.count} payment(s){Object.keys(r.auto).length > 0 && <> · auto debit {money(r.auto)}</>}{r.no_amount > 0 && <span className="text-amber-700"> · {r.no_amount} without amount</span>}
        </div>
      </div>
    ))}
  </div>
);
